// Common
export const ROOT_PATH = 'root';

// Instant credit tax
export const INSTANT_TAX_CREDIT_HOW_IT_WORKS = 'InstantTaxCreditHowItWorks';
export const INSTANT_TAX_CREDIT_USER_ADDRESS = 'InstantTaxCreditUserAddress';
export const INSTANT_TAX_CREDIT_USER_BANK_INFO = 'InstantTaxCreditUserBankInfo';
export const INSTANT_TAX_CREDIT_USER_INFO = 'InstantTaxCreditUserInfo';
export const INSTANT_TAX_CREDIT_HOW_TO_FINALISE = 'InstantTaxCreditHowToFinalise';

export type RoutePath =
  | typeof ROOT_PATH
  | typeof INSTANT_TAX_CREDIT_HOW_IT_WORKS
  | typeof INSTANT_TAX_CREDIT_USER_ADDRESS
  | typeof INSTANT_TAX_CREDIT_USER_BANK_INFO
  | typeof INSTANT_TAX_CREDIT_HOW_TO_FINALISE
  | typeof INSTANT_TAX_CREDIT_USER_INFO;

const ROUTES = {
  [ROOT_PATH]: '/',
  [INSTANT_TAX_CREDIT_HOW_IT_WORKS]: '/comment-ca-marche',
  [INSTANT_TAX_CREDIT_USER_ADDRESS]: '/mon-domicile',
  [INSTANT_TAX_CREDIT_USER_BANK_INFO]: '/mes-infos-bancaires',
  [INSTANT_TAX_CREDIT_USER_INFO]: '/mes-coordonnees',
  [INSTANT_TAX_CREDIT_HOW_TO_FINALISE]: '/comment-finaliser',
};

export const route = (path: RoutePath) => ROUTES[path];

type Screen = {
  helpLink?: string;
  withBackButton?: boolean;
  screenName: RoutePath;
};

export const INSTANT_TAX_CREDIT_HELP_LINK =
  'https://help.wecasa.fr/fr/articles/6138291-avance-immediate-de-credit-d-impot-creation-de-votre-compte-avance-immediate';

export const SCREENS: Record<string, Screen> = {
  [route('root')]: {
    screenName: 'root',
  },
  [route(INSTANT_TAX_CREDIT_HOW_IT_WORKS)]: {
    helpLink: INSTANT_TAX_CREDIT_HELP_LINK,
    screenName: 'InstantTaxCreditHowItWorks',
  },
  [route(INSTANT_TAX_CREDIT_USER_INFO)]: {
    helpLink: INSTANT_TAX_CREDIT_HELP_LINK,
    withBackButton: true,
    screenName: 'InstantTaxCreditUserInfo',
  },
  [route(INSTANT_TAX_CREDIT_USER_BANK_INFO)]: {
    helpLink: INSTANT_TAX_CREDIT_HELP_LINK,
    withBackButton: true,
    screenName: 'InstantTaxCreditUserBankInfo',
  },
  [route(INSTANT_TAX_CREDIT_USER_ADDRESS)]: {
    helpLink: INSTANT_TAX_CREDIT_HELP_LINK,
    withBackButton: true,
    screenName: 'InstantTaxCreditUserAddress',
  },
  [route(INSTANT_TAX_CREDIT_HOW_TO_FINALISE)]: {
    helpLink: INSTANT_TAX_CREDIT_HELP_LINK,
    screenName: 'InstantTaxCreditHowToFinalise',
  },
};
